import { render } from "./OrderStateButton.vue?vue&type=template&id=36e416f1&scoped=true"
import script from "./OrderStateButton.vue?vue&type=script&lang=js"
export * from "./OrderStateButton.vue?vue&type=script&lang=js"

import "./OrderStateButton.vue?vue&type=style&index=0&id=36e416f1&lang=scss&scoped=true"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e416f1"]])

export default __exports__